  <kmd-modal class="delete-modal" [id]="modalId" modalSize="small" [headline]="headline" (clickedOutside)="close()">
      <div id="text">{{description}}</div>
      <div class="modal-buttons-container">
        <button id="cancel-button" (click)="close()" kmdSecondaryButton>Cancel</button>
        <button id="delete-button" (click)="confirmDelete()" kmdFeaturedButton>Delete</button>
      </div>
  </kmd-modal>
